export const truncateApiKey = (apiKey: string): string => {
  if (apiKey.split('-').length > 2) {
    return `${apiKey.split('-').slice(0, 2).join('-')}••••`;
  }

  return `${apiKey.slice(-8)}••••`;
};
